import Image from "components/Elements/Image/Image.tsx";
import PlansCardFeatures from "./PlansCardFeatures";
import PriceDisplayElem from "./PriceDisplayElem.tsx";
import CardPlanButton from "./CardPlanButton.tsx";
import EnterpriseCardFeature from "./EnterpriseCardFeature.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import config from "config.ts";

import "./PlanCard.scss";

const PlanCard = ({ card, isYearly, setClickedCard }) => {
  const { getTextByKey, getLanguage, getBlackFridayTime } = useContent();

  const isMostPopularCard = card.Subscription_SystemName === "business";
  const isEnterprise = card.Subscription_SystemName === "enterprise";

  const handleSetClickedCard = (sysName) => {
    if (!isEnterprise) setClickedCard(sysName);
  };

  const {
    CouponCode: couponCode,
    IconSaleUrl: iconSaleUrl,
    PrecentSale: discount,
  } = card.SaleCoupon || {};

  return (
    <div
      onClick={() => handleSetClickedCard(card.Subscription_SystemName)}
      className={`plans-card plan-card-${getLanguage()}${
        isMostPopularCard ? " most-popular-card" : ""
      }${isEnterprise ? " enterprise-card" : ""}`}
    >
      {getBlackFridayTime() && isYearly ? (
        <Image src={iconSaleUrl} className="black-friday-label" />
      ) : null}
      {isMostPopularCard ? (
        <div className="most-popular-card-header">
          {getTextByKey("most-popular")}
        </div>
      ) : null}
      <div className="plans-card-container">
        <div className="plans-card-header">
          <h3>{getTextByKey(card.Subscription_Title)}</h3>
          <div className="card-image">
            <Image
              src={
                card.IconUrl ||
                `${config.api.resource}/assets/images/plans/business.svg`
              }
              alt=""
              title=""
            />
          </div>
        </div>
        <div className="plans-card-price">
          {isEnterprise ? (
            <div className="enterprise-card-title">
              {getTextByKey("enterprise-card-title")}
            </div>
          ) : (
            <>
              <PriceDisplayElem
                isYearly={isYearly}
                prices={card.Prices}
                discount={discount}
              />
              <div className="type-billing">
                {getTextByKey(isYearly ? "billed-yearly" : "billed-monthly")}
              </div>
            </>
          )}
        </div>
        <PlansCardFeatures constKey={card.ConstText} />
      </div>
      {isEnterprise ? <EnterpriseCardFeature /> : null}
      <CardPlanButton
        isYearly={isYearly}
        sysName={card.Subscription_SystemName}
        couponCode={couponCode}
      />
    </div>
  );
};

export default PlanCard;
